// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__F7vsX","line":"default_line__c8af7","headline":"default_headline__uU2z1"};